import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.mediumExtraBold}

  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const CounterContainer = styled.span`
  position: relative;
`;
const Counter = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold};

  position: relative;
  top: 0;
  padding: ${({ theme }) => theme.spacing(1, 3)};
  border-radius: 10px;
  height: ${({ theme }) => theme.spacing(8)};
  border: solid 1px ${({ theme }) => theme.colors.corporateWhite};
`;
const Price = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallBold}
`;

function ButtonWithCounter({ itemsCount, text, subtotal }) {
  return (
    <Container>
      <CounterContainer>
        <Counter>{itemsCount}</Counter>
      </CounterContainer>
      <span>{text}</span>
      <Price>{subtotal}</Price>
    </Container>
  );
}

ButtonWithCounter.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  subtotal: PropTypes.object,
};

export default ButtonWithCounter;
